import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_17: FaireProductEntity = {
  token: "starter_collection_17",
  type: "product",
  name: "Smoked Rainbow Trout",
  brandName: "Fishwife",
  imageUrl: "",
  priceDollars: 12,
  msrpDollars: 24,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
